import React from 'react';
import FilaTablaTerritorios from "./FilaTablaTerritorios";

const TablaTerritorios = (props) => {
  
  const getTerritorios = (camaraSeleccionada) => {
    let territorios = [];
    territorios = camaraSeleccionada.mapagan;
    return territorios;
  }
  const listaTerritorios = getTerritorios(props.camaraSeleccionada);
  return <div>
      {listaTerritorios.map((territorio, i) => {
        return(<FilaTablaTerritorios hayGanadores={territorio.mesesc > 0} key={i} territorio={territorio}/>)
      })}
    </div>;
};

export default TablaTerritorios;
